'use client';
import React from 'react';
import { faBars } from '@fortawesome/pro-solid-svg-icons/faBars';
import { SimpleSearch } from './SimpleSearch';
import { NavigationLogo } from '../../NavigationLogo';
import { Icon } from '@benzinga/core-ui';
import styles from './SimpleHeaderMobile.module.scss';

import { SimpleHeaderMenu } from './SimpleHeaderMenu';
import { NavigationMenus } from './SimpleHeader';
import { NavigationHeaderProps } from '../../../../entities';
import { useSyncStickyNavOffset } from '../../../../hooks/useSyncStickyNavOffset';

interface SimpleHeaderMobileProps extends NavigationHeaderProps {
  menus?: NavigationMenus;
}

export const SimpleHeaderMobile: React.FC<SimpleHeaderMobileProps> = ({ logoVariant, menus, sticky = true }) => {
  const [menuVisible, setMenuVisible] = React.useState(false);
  const navBarRef = React.useRef<HTMLDivElement | null>(null);
  useSyncStickyNavOffset(navBarRef, Boolean(sticky));

  return (
    <div className={styles.navWrapper}>
      <div className={styles.navBar} id="navigation-header" ref={navBarRef}>
        <Icon className="text-xl" icon={faBars} onClick={() => setMenuVisible(true)} />
        <NavigationLogo deviceType="mobile" logoVariant={logoVariant} />
        <SimpleSearch />
      </div>
      <SimpleHeaderMenu
        logoVariant={logoVariant}
        menus={menus?.primary ?? []}
        onClose={() => setMenuVisible(false)}
        visible={menuVisible}
      />
    </div>
  );
};
